
import { Apis } from '@/appSettings'
import axios from 'axios'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useUrl } from '.'

export const useTranslationsGetUiBundle = () => {
  const url = useUrl(Apis.translations)

  return useQuery({
    queryKey: ['translations'],
    queryFn: async () => {
      const response = await axios.get<Record<string, string>>(`${url}/GetUiBundle`)

      return response.data
    },
    staleTime: longStaleTime,
  })
}

export const useReloadTranslations = () => {
  const url = useUrl(Apis.translations)

  return useMutation({
    mutationFn: () =>
      axios.post(`${url}/ReloadTranslations`),
  })
}